/* LOOSNUP v2 — motion, the scroll story and the sleep-cycle timeline.
   Everything here is progressive: without this file the page is complete. */
(function () {
  var doc = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  doc.classList.add('ln-js');

  /* ---------- run work only while an element is on (or near) screen ---------- */
  function whileVisible(el, onChange, margin) {
    if (!('IntersectionObserver' in window)) { onChange(true); return; }
    new IntersectionObserver(function (es) { es.forEach(function (e) { onChange(e.isIntersecting); }); },
      { rootMargin: margin || '200px 0px' }).observe(el);
  }

  /* ---------- staggered entrances ---------- */
  function initReveal(root) {
    var groups = (root || document).querySelectorAll('[data-reveal-group]');
    groups.forEach(function (g) {
      var step = parseInt(g.getAttribute('data-reveal-group'), 10) || 80;
      g.querySelectorAll('[data-reveal]').forEach(function (el, i) {
        if (!el.style.getPropertyValue('--d')) el.style.setProperty('--d', i * step + 'ms');
      });
    });
    var items = (root || document).querySelectorAll('[data-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        el.classList.add('is-in');
        io.unobserve(el);
        /* once it has arrived, drop the stagger so hover feedback is instant */
        var d = parseInt(el.style.getPropertyValue('--d'), 10) || 0;
        setTimeout(function () { el.style.setProperty('--d', '0ms'); }, d + 750);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* safety net: anything on screen or already scrolled past is shown, even if
     the observer never fired (fast jumps, anchor links, print, slow devices) */
  function sweepReveals() {
    var limit = window.innerHeight;
    /* read every position first, then write, so the sweep causes one layout, not one per element */
    var due = [].filter.call(document.querySelectorAll('[data-reveal]:not(.is-in)'), function (el) { return el.getBoundingClientRect().top < limit; });
    due.forEach(function (el) { el.classList.add('is-in'); });
  }
  var sweepTimer;
  window.addEventListener('scroll', function () { clearTimeout(sweepTimer); sweepTimer = setTimeout(sweepReveals, 120); }, { passive: true });
  window.addEventListener('load', function () { setTimeout(sweepReveals, 1500); });


  /* ---------- shared: 12-hour clock label ---------- */
  function fmtTime(mins) {
    mins = ((mins % 1440) + 1440) % 1440;
    var h = Math.floor(mins / 60), m = mins % 60;
    var ap = h >= 12 ? 'PM' : 'AM';
    var h12 = h % 12 === 0 ? 12 : h % 12;
    return h12 + ':' + (m < 10 ? '0' : '') + m + ' ' + ap;
  }

  /* ---------- hero: the pouch drifts a little slower than the page ---------- */
  function initHeroDrift() {
    if (reduce) return;
    var img = document.querySelector('[data-ln-drift]');
    if (!img) return;
    var ticking = false;
    var heroOn = true;
    whileVisible(img, function (v) { heroOn = v; if (v) onScroll(); });
    function onScroll() {
      if (ticking || !heroOn) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = Math.min(window.scrollY, 900);
        img.style.transform = 'translate3d(0,' + (y * -0.08).toFixed(1) + 'px,0) rotate(' + (y * 0.006).toFixed(2) + 'deg)';
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }


  /* ---------- scroll story: one line highlighted at a time as you scroll (passed = cream,
     current = honey, upcoming = light blue). Pins on desktop; on phones each line lights as it
     crosses a reading line. The clock lands on 6:00 AM as the last line lights. Reduced motion:
     no animation, first line honey and the rest cream, clock shown at 6:00 AM. ---------- */
  function initScrollStory(root) {
    (root || document).querySelectorAll('[data-ln-hs]').forEach(function (sec) {
      if (sec.dataset.ready) return;
      sec.dataset.ready = '1';
      var lines = [].slice.call(sec.querySelectorAll('.ln-hs2__lines > .ln-hs2__line'));
      var n = lines.length;
      var hour = sec.querySelector('.hs-hour'), min = sec.querySelector('.hs-min'), ring = sec.querySelector('.cring');
      var timeEl = sec.querySelector('[data-hs-time]');
      var C = ring ? 2 * Math.PI * 112 : 0;
      if (ring) ring.style.strokeDasharray = C;
      function clock(q) {
        var mins = 22 * 60 + q * 8 * 60;
        if (hour) hour.setAttribute('transform', 'rotate(' + (((mins / 60) % 12) * 30).toFixed(1) + ' 120 120)');
        if (min) min.setAttribute('transform', 'rotate(' + ((mins % 60) * 6).toFixed(1) + ' 120 120)');
        if (ring) ring.style.strokeDashoffset = (C * (1 - q)).toFixed(1);
        if (timeEl) timeEl.textContent = fmtTime(Math.round(mins / 15) * 15);
      }
      if (reduce || !n) { clock(1); return; }
      sec.classList.add('is-live');
      var mq = window.matchMedia('(min-width: 901px)');
      var ticking = false, last = -2;
      var VH = window.innerHeight; /* cached; refreshed on resize so the scroll loop never forces layout */
      window.addEventListener('resize', function () { VH = window.innerHeight; });
      function highlight(cur) {
        if (cur === last) return;
        last = cur;
        lines.forEach(function (el, i) {
          el.classList.toggle('is-past', i < cur);
          el.classList.toggle('is-current', i === cur);
        });
      }
      /* measuring happens in the scroll event, where layout is still clean; the animation
         frame only writes. Reading inside the frame would force a layout after other
         animations on the page (the graph) have already written styles in that frame. */
      var pending = null;
      function measure() {
        var vh = VH, cur, q;
        if (sec.classList.contains('is-pinned')) {
          /* the pin ends exactly when the last line lights and the clock hits 6:00 AM */
          var r = sec.getBoundingClientRect();
          var total = sec.offsetHeight - vh;
          var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
          /* sub-pixel section offsets can leave the scroll a fraction short of the end */
          if (total > 0 && total + r.top < 2) p = 1;
          cur = n > 1 ? Math.min(n - 1, Math.floor(p * (n - 1) + 1e-6)) : 0;
          q = p;
        } else {
          var readY = vh * 0.6;
          var mids = lines.map(function (el) { var b = el.getBoundingClientRect(); return b.top + b.height / 2; });
          cur = -1;
          mids.forEach(function (m, i) { if (m <= readY) cur = i; });
          var span = mids[n - 1] - mids[0];
          q = span > 0 ? Math.min(1, Math.max(0, (readY - mids[0]) / span)) : (cur >= 0 ? 1 : 0);
        }
        return [cur, q];
      }
      function paint() {
        ticking = false;
        var m = pending || measure(); pending = null;
        highlight(m[0]);
        clock(m[1]);
      }
      var near = true;
      whileVisible(sec, function (v) { near = v; if (v) onScroll(); }, '50% 0px');
      function onScroll() { if (!near) return; pending = measure(); if (!ticking) { ticking = true; requestAnimationFrame(paint); } }
      /* pinned length: the original pace per line (setting length split over n lines),
         but only for the n-1 hand-offs, so there is no dead scroll after the last one */
      var lenVh = parseFloat(getComputedStyle(sec).getPropertyValue('--len')) || 180;
      function sizePin() {
        if (!sec.classList.contains('is-pinned')) { sec.style.height = ''; return; }
        var vh = window.innerHeight, travel = (lenVh / 100 * vh - vh) * (n - 1) / n;
        sec.style.height = Math.round(vh + travel) + 'px';
      }
      function setMode() { sec.classList.toggle('is-pinned', mq.matches); sizePin(); last = -2; paint(); }
      window.addEventListener('resize', sizePin);
      if (mq.addEventListener) mq.addEventListener('change', setMode);
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      setMode();
    });
  }

  /* ---------- sleep-cycle timeline: plays like a timelapse (steady glide, fill grows, markers
     light as the handle reaches them), holds on the last stop, then eases back and loops.
     No pause control by design; never autoplays under prefers-reduced-motion. ---------- */
  function initTimeline(root) {
    (root || document).querySelectorAll('[data-ln-timeline]').forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      var range = box.querySelector('.ln-tl__range');
      var slider = box.querySelector('.ln-tl__slider');
      var stage = box.querySelector('.ln-tl__stage');
      var stops = [].slice.call(box.querySelectorAll('.ln-tl__stop'));
      var panels = [].slice.call(box.querySelectorAll('.ln-tl__points'));
      var max = stops.length - 1;
      if (!range || max < 1) return;
      var perStop = parseInt(box.getAttribute('data-interval') || '4000', 10); // ms from one stop to the next
      var HOLD = 4000, RESET = 900, RESUME = 5000;
      var value = 0, current = -1, mode = 'idle', raf = null, last = 0, holdUntil = 0, resetFrom = 0, resetStart = 0;
      var resumeTimer = null, waiting = false, visible = false, started = false;

      /* uses the width cached by build(), so the animation loop never forces a layout */
      function pxPerStop() { return Math.max(1, ((W || 0) - 32) / max); }
      function nameOf(i) { return stops[i].querySelector('.ln-tl__name').textContent.trim(); }

      /* the rising curve: shallow at first, steeper toward the end (illustrative, not data).
         Must match the marker heights set in the section (--t). */
      var feather = box.querySelector('.ln-tl__featherg');
      var svg = box.querySelector('.ln-tl__svg'), knob = box.querySelector('.ln-tl__knob'), clip = box.querySelector('.ln-tl__cliprect');
      var curves = [].slice.call(box.querySelectorAll('.ln-tl__curve')), area = box.querySelector('.ln-tl__area');
      var K = 1.4436, W = 0, G = 0, HALF = 16, narrow = false; /* stops at 8%, 24%, 50%, 92% of the graph height */
      function rise(u) { return 0.08 + 0.84 * (Math.exp(K * u) - 1) / (Math.exp(K) - 1); }
      function px(u) { return HALF + (W - 2 * HALF) * u; }
      function py(u) { return G * (1 - rise(u)); }
      function build() {
        if (!svg) return;
        W = range.getBoundingClientRect().width; G = range.getBoundingClientRect().height;
        narrow = window.innerWidth <= 900; /* read once here, never inside the animation loop */
        if (!W || !G) return;
        svg.setAttribute('viewBox', '0 0 ' + W.toFixed(1) + ' ' + G.toFixed(1));
        var d = '';
        for (var k = 0; k <= 60; k++) { var u = k / 60; d += (k ? ' L' : 'M') + px(u).toFixed(1) + ',' + py(u).toFixed(1); }
        curves.forEach(function (c) { c.setAttribute('d', d); });
        if (area) area.setAttribute('d', d + ' L' + px(1).toFixed(1) + ',' + G.toFixed(1) + ' L' + px(0).toFixed(1) + ',' + G.toFixed(1) + ' Z');
      }
      function place(u) {
        if (!W) return;
        var x = px(u), y = py(u);
        if (knob) knob.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)';
        if (clip) clip.setAttribute('width', x.toFixed(1));
        /* phones: the glow fades out over the last 44px before the handle (desktop keeps a solid edge) */
        if (feather) { var f = narrow ? 44 : 0; feather.setAttribute('x1', (x - f).toFixed(1)); feather.setAttribute('x2', (x + (f ? 0 : 1)).toFixed(1)); }
      }

      function paint(v) {
        value = Math.max(0, Math.min(max, v));
        range.value = value;
        slider.style.setProperty('--p', (value / max).toFixed(4));
        place(value / max);
        stops.forEach(function (b, k) {
          b.classList.toggle('is-done', value >= k - 0.001);
          b.classList.toggle('is-under', Math.abs(value - k) * pxPerStop() < 14);
        });
        var i = Math.floor(value + 0.001);
        if (i !== current) show(i);
      }
      function show(i) {
        var first = current === -1;
        current = i;
        stops.forEach(function (b, k) { b.classList.toggle('is-active', k === i); });
        panels.forEach(function (p, k) { var on = k === i; p.classList.toggle('is-active', on); if (on) p.removeAttribute('aria-hidden'); else p.setAttribute('aria-hidden', 'true'); });
        range.setAttribute('aria-valuetext', nameOf(i));
        if (reduce || first) { stage.textContent = nameOf(i); return; }
        stage.classList.add('is-fading');
        setTimeout(function () { stage.textContent = nameOf(current); stage.classList.remove('is-fading'); }, 220);
      }
      function frame(now) {
        var dt = Math.min(64, now - last); last = now;
        if (mode === 'play') {
          var v = value + dt / perStop;
          if (v >= max) { paint(max); mode = 'hold'; holdUntil = now + HOLD; }
          else paint(v);
        } else if (mode === 'hold') {
          if (now >= holdUntil) { mode = 'reset'; resetFrom = value; resetStart = now; }
        } else if (mode === 'reset') {
          var t = Math.min(1, (now - resetStart) / RESET), e = t < .5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
          paint(resetFrom * (1 - e));
          if (t >= 1) { paint(0); mode = 'play'; }
        } else if (mode === 'jump') {
          var tj = Math.min(1, (now - resetStart) / 450), ej = 1 - Math.pow(1 - tj, 3);
          paint(resetFrom + (jumpTo - resetFrom) * ej);
          if (tj >= 1) mode = 'idle';
        }
        if (mode !== 'idle') raf = requestAnimationFrame(frame); else raf = null;
      }
      var jumpTo = 0;
      function run(m) {
        mode = m;
        if (!raf) { last = performance.now(); raf = requestAnimationFrame(frame); }
      }
      function halt() { mode = 'idle'; cancelAnimationFrame(raf); raf = null; }
      function resume() { waiting = false; play(); }
      function play() {
        if (reduce || !visible || waiting) return;
        if (value >= max - 0.001) { mode = 'hold'; holdUntil = performance.now() + HOLD; run('hold'); return; }
        run('play');
      }
      function jump(i) {
        clearTimeout(resumeTimer); halt();
        if (reduce) { paint(i); }
        else { jumpTo = i; resetFrom = value; resetStart = performance.now(); run('jump'); }
        waiting = true; resumeTimer = setTimeout(resume, RESUME);
      }
      function userTouched() { clearTimeout(resumeTimer); halt(); waiting = true; resumeTimer = setTimeout(resume, RESUME); }

      var downX = null;
      range.addEventListener('pointerdown', function (e) { downX = e.clientX; userTouched(); });
      /* a click on the handle itself (no drag) snaps to the nearest stop */
      range.addEventListener('pointerup', function (e) {
        if (downX !== null && Math.abs(e.clientX - downX) < 4) jump(Math.round(value));
        downX = null;
      });
      range.addEventListener('input', function () { userTouched(); paint(parseFloat(range.value)); });
      range.addEventListener('change', function () { jump(Math.round(parseFloat(range.value))); });
      range.addEventListener('keydown', function (e) {
        var i = Math.round(value);
        if (e.key === 'ArrowRight' || e.key === 'ArrowUp') i = Math.min(max, Math.floor(value + 0.001) + 1);
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') i = Math.max(0, Math.ceil(value - 0.001) - 1);
        else if (e.key === 'Home') i = 0;
        else if (e.key === 'End') i = max;
        else return;
        e.preventDefault(); jump(i);
      });
      stops.forEach(function (b, k) { b.addEventListener('click', function () { jump(k); }); });

      build(); paint(0);
      if ('ResizeObserver' in window) new ResizeObserver(function () { build(); place(value / max); }).observe(range);
      else window.addEventListener('resize', function () { build(); place(value / max); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            visible = en.isIntersecting;
            if (visible) {
              if (!started) { started = true; paint(0); }
              if (mode === 'idle') play();
            } else if (mode === 'play' || mode === 'hold' || mode === 'reset') halt();
          });
        }, { threshold: 0.5 }).observe(box);
      }
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { if (mode !== 'idle' && mode !== 'jump') halt(); }
        else if (visible && mode === 'idle') play();
      });
    });
  }


  /* ---------- accordions (ingredients, FAQ, comparison); one delegated listener, works
     for sections added in the theme editor too ---------- */
  function setOpen(cell, panel, btn, open) {
    cell.classList.toggle('open', open);
    panel.style.maxHeight = open ? panel.scrollHeight + 'px' : null;
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.ln-ing__btn, .ln-faq__item > button, .ln-vs__q');
    if (!b) return;
    if (b.classList.contains('ln-ing__btn')) {
      var card = b.parentElement;
      setOpen(card, card.querySelector('.ln-ing__panel'), null, !card.classList.contains('open'));
    } else if (b.classList.contains('ln-vs__q')) {
      var cell = b.parentElement;
      setOpen(cell, cell.querySelector('.ln-vs__ans'), b, !cell.classList.contains('open'));
    } else {
      /* FAQ: one answer open at a time within its section */
      var item = b.parentElement, list = b.closest('.ln-faq__list') || document, was = item.classList.contains('open');
      list.querySelectorAll('.ln-faq__item').forEach(function (x) { setOpen(x, x.querySelector('.ln-faq__ans'), x.querySelector('button'), false); });
      if (!was) setOpen(item, item.querySelector('.ln-faq__ans'), b, true);
    }
  });

  /* the scrolling strip pauses its CSS animation while off screen */
  function initMarquee(root) {
    (root || document).querySelectorAll('.ln-marquee').forEach(function (m) {
      if (m.dataset.ready) return; m.dataset.ready = '1';
      whileVisible(m, function (v) { m.classList.toggle('is-offscreen', !v); }, '0px');
    });
  }


  /* ---------- contact form: branded inline validation before the real Shopify submit ---------- */
  function initContact(root) {
    (root || document).querySelectorAll('[data-ln-contact]').forEach(function (form) {
      if (form.dataset.ready) return; form.dataset.ready = '1';
      var rules = [
        { el: form.querySelector('#LnContact-email'), ok: function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); } },
        { el: form.querySelector('#LnContact-body'), ok: function (v) { return v.trim().length > 0; } }
      ];
      function check(r, show) {
        if (!r.el) return true;
        var good = r.ok(r.el.value.trim()), field = r.el.closest('.ln-field'), err = document.getElementById(r.el.getAttribute('aria-describedby'));
        if (show || field.classList.contains('is-invalid')) {
          field.classList.toggle('is-invalid', !good);
          if (good) r.el.removeAttribute('aria-invalid'); else r.el.setAttribute('aria-invalid', 'true');
          if (err) err.hidden = good;
        }
        return good;
      }
      rules.forEach(function (r) { if (r.el) { r.el.addEventListener('blur', function () { if (r.el.value) check(r, true); }); r.el.addEventListener('input', function () { check(r, false); }); } });
      form.addEventListener('submit', function (e) {
        var firstBad = null;
        rules.forEach(function (r) { if (!check(r, true) && !firstBad) firstBad = r.el; });
        if (firstBad) { e.preventDefault(); firstBad.focus(); }
      });
    });
  }


  /* ---------- shop gallery: arrows and swipe, following the thumbnail order ---------- */
  function initGallery(root) {
    (root || document).querySelectorAll('[data-ln-gallery]').forEach(function (stage) {
      if (stage.dataset.ready) return; stage.dataset.ready = '1';
      var media = stage.closest('.ln-bb__media') || stage.parentElement;
      var thumbs = [].slice.call(media.querySelectorAll('.ln-bb__thumb'));
      if (thumbs.length < 2) return;
      function cur() { var i = thumbs.findIndex(function (t) { return t.classList.contains('sel'); }); return i < 0 ? 0 : i; }
      function hydrate(t) {
        var slide = t && stage.querySelector('.ln-bb__slide[data-i="' + t.getAttribute('data-i') + '"]');
        if (!slide) return;
        slide.querySelectorAll('img[data-srcset], img[data-src]').forEach(function (img) {
          if (img.dataset.srcset) { img.srcset = img.dataset.srcset; img.removeAttribute('data-srcset'); }
          if (img.dataset.src) { img.src = img.dataset.src; img.removeAttribute('data-src'); }
          img.loading = 'eager';
        });
      }
      /* the shown slide loads now; only the one after it is fetched ahead, so the next click is instant */
      function warm(i) { hydrate(thumbs[i]); hydrate(thumbs[(i + 1) % thumbs.length]); }
      function go(d) {
        var i = (cur() + d + thumbs.length) % thumbs.length;
        thumbs[i].click();
        var strip = thumbs[i].parentElement;
        if (strip && strip.scrollWidth > strip.clientWidth) strip.scrollTo({ left: thumbs[i].offsetLeft - strip.clientWidth / 2 + thumbs[i].offsetWidth / 2, behavior: reduce ? 'auto' : 'smooth' });
        warm(i);
      }
      stage.querySelector('.ln-bb__arrow--prev').addEventListener('click', function () { go(-1); });
      stage.querySelector('.ln-bb__arrow--next').addEventListener('click', function () { go(1); });
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { warm(i); }); });
      stage.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); } else if (e.key === 'ArrowRight') { e.preventDefault(); go(1); } });
      /* swipe: horizontal drags change image; vertical scrolling is left to the page */
      var x0 = null, y0 = 0;
      stage.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse' || e.target.closest('.ln-bb__arrow')) return; x0 = e.clientX; y0 = e.clientY; });
      stage.addEventListener('pointerup', function (e) {
        if (x0 === null) return;
        var dx = e.clientX - x0, dy = e.clientY - y0; x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) go(dx < 0 ? 1 : -1);
      });
      stage.addEventListener('pointercancel', function () { x0 = null; });
    });
  }

  /* ---------- email signup: Shopify reloads the page at #<form id> after a signup, and every
     customer form on the page renders the same success or error state. Keep that state only on the
     form that was used; the others go back to their empty field. ---------- */
  function initSignup() {
    var forms = document.querySelectorAll('form.js-ln-signup');
    if (forms.length < 2) return;
    var used = location.hash.slice(1);
    if (!used) return;
    forms.forEach(function (f) {
      if (f.id === used) return;
      f.querySelectorAll('input[type=email],button').forEach(function (el) { el.hidden = false; el.removeAttribute('aria-invalid'); });
      f.querySelectorAll('[data-ln-signup-ok],[data-ln-signup-err]').forEach(function (el) { el.hidden = true; });
    });
  }
  /* ---------- Klaviyo: every signup also goes to the Klaviyo "Newsletter" list through Klaviyo's public
     client subscribe API (public site key only, set in snippets/ln-klaviyo). The Shopify customer form still
     posts as before, so the $10 off code keeps its Shopify first-order check. Sent with keepalive because the
     footer and Night Owl Club forms reload the page right after. ---------- */
  window.lnKlaviyoSubscribe = function (email, props) {
    var k = window.lnKlaviyo;
    if (!k || !k.company || !k.list || !email) return Promise.resolve(false);
    /* tie this browser to the profile, so cart and product views reach the cart and browse flows */
    try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email }); } catch (e) {}
    var body = { data: { type: 'subscription', attributes: {
      profile: { data: { type: 'profile', attributes: { email: email, properties: props || {} } } },
      custom_source: 'LOOSNUP ' + ((props && props.signup_source) || 'site')
    }, relationships: { list: { data: { type: 'list', id: k.list } } } } };
    return fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(k.company), {
      method: 'POST', keepalive: true,
      headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2024-10-15' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.ok; }).catch(function () { return false; });
  };
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('form.js-ln-signup');
    if (!f) return;
    var email = f.querySelector('input[type=email]');
    if (!email || !email.value || !email.checkValidity()) return;
    window.lnKlaviyoSubscribe(email.value.trim(), { signup_source: f.getAttribute('data-ln-source') || 'site' });
  });
  document.addEventListener('input', function (e) {
    var f = e.target.closest && e.target.closest('form.js-ln-signup');
    if (!f) return;
    e.target.removeAttribute('aria-invalid');
    var err = f.querySelector('[data-ln-signup-err]'); if (err) err.hidden = true;
  });

  function init(root) { initReveal(root); initScrollStory(root); initTimeline(root); initMarquee(root); initContact(root); initGallery(root); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); initHeroDrift(); initSignup(); });
  else { init(); initHeroDrift(); initSignup(); }

  /* re-run inside the theme editor when a section is added or changed */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
